import Http from "./Http";

export class StripeService extends Http {
  /**
   * Link user to Stripe
   * @param {object} body
   * @param {number} body.countryId
   */
  connectStripe(body) {
    return this.post("/stripe", body);
  }

  /**
   * Get Stripe countries
   */
  getStripeCountries() {
    return this.get("/stripe/countries");
  }
}

export default new StripeService();
